export const VehicleCategories = {
  CARS_TRUCKS: 1,
  CARS_TOW_TRUCKS: 2,
  TOW_TRUCKS_OR_SEMI: 3,
  BUS_OR_2_AXEL_TRUCKS: 4,
  BUS_OR_3_AXEL_TRUCKS: 5,
}

export const VehicleCategoryLabels = {
  [VehicleCategories.CARS_TRUCKS]: 'Automóveis e Camionetes',
  [VehicleCategories.CARS_TOW_TRUCKS]: 'Automóveis e Camionetes com reboque',
  [VehicleCategories.TOW_TRUCKS_OR_SEMI]: 'Caminhões com reboque ou semi-reboque',
  [VehicleCategories.BUS_OR_2_AXEL_TRUCKS]: 'Ônibus e Caminhões com 2 eixos, Tratores, Tratores com reboque, Trailers',
  [VehicleCategories.BUS_OR_3_AXEL_TRUCKS]: 'Ônibus e Caminhões com 3 eixos',
}
